import React, { useRef, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

function Contact() {
	const [squareColor, setSquareColor] = useState('#8ea0aa');

	// Helper function to convert hex to HSL
	const hexToHsl = (hex) => {
		const r = parseInt(hex.slice(1, 3), 16) / 255;
		const g = parseInt(hex.slice(3, 5), 16) / 255;
		const b = parseInt(hex.slice(5, 7), 16) / 255;

		const max = Math.max(r, g, b);
		const min = Math.min(r, g, b);
		let h, s, l = (max + min) / 2;

		if (max === min) {
			h = s = 0; // achromatic
		} else {
			const d = max - min;
			s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
			switch (max) {
				case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
				case g: h = ((b - r) / d + 2) / 6; break;
				case b: h = ((r - g) / d + 4) / 6; break;
				default: h = 0;
			}
		}
		return { h: h * 360, s: s * 100, l: l * 100 };
	};

	// Calculate square color based on time of day (12-hour cycle through spectrum)
	useEffect(() => {
		// Get starting hue from initial color
		const startColor = hexToHsl('#8ea0aa');
		const startHue = startColor.h;

		const calculateSquareColor = () => {
			const now = new Date();
			// Get seconds since the start of the current minute
			const seconds = now.getSeconds();
			// Total seconds in 1 minute cycle
			const secondsInCycle = 60;
			// Calculate progress through the 1-minute cycle (0 to 1)
			const progress = seconds / secondsInCycle;
			// Calculate hue by adding progress * 360 to starting hue
			const hue = (startHue + progress * 360) % 360;
			// Use HSL with fixed saturation and lightness for vibrant colors
			const saturation = 50;
			const lightness = 65;
			const hslColor = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
			setSquareColor(hslColor);
		};

		// Calculate initial color
		calculateSquareColor();

		// Update color every second for smooth transition
		const interval = setInterval(calculateSquareColor, 1000);

		return () => clearInterval(interval);
	}, []);

	return (
		<Container fluid 
			className="home-section" id="contact" 
		>
			<header>
				<nav>
					<ul>
						<li><Link to="/">Home</Link></li>
						<li><Link to="/project">Projects</Link></li>
						<li><Link to="/about">About</Link></li>
						<li className="active-page">(Here)</li>
					</ul>
				</nav>
			</header>        
			<Container className="home-content">
				<div className="square-text-container">
					<div className="square-wrapper">
						{/* Square element */}
						<div className="square-box" style={{ backgroundColor: squareColor }}></div>
						
						{/* Top edge text - horizontal, left to right */}
						<div className="square-text square-text-top">
							<a href="mailto:ez2294@columbia.edu">EMAIL</a>
						</div>
						
						{/* Right edge text - vertical, top to bottom */}
						<div className="square-text square-text-right">
							<a href="https://www.instagram.com/modeaxe" target="_blank" rel="noreferrer noopener">INSTAGRAM</a>
						</div>
						
						{/* Bottom edge text - horizontal, rotated 180° */}
						<div className="square-text square-text-bottom">
							<a href="https://www.linkedin.com/in/elijahzulu/" target="_blank" rel="noreferrer noopener">LINKEDIN</a>
						</div>
						
						{/* Left edge text - vertical, bottom to top */}
						<div className="square-text square-text-left">
							<Link to="/">HOME</Link>
						</div>
					</div>
				</div>
			</Container>
		</Container>
	);
}

export default Contact;

